import { Box, Gap, Heading, Image, P, Page } from '@salecycle/ui-component-library';
import { useTranslation } from 'react-i18next';
import { useTemplateEditorState } from '../../../../context/UseTemplateEditorContext';
import { LeftConfigContainer, LogoBox } from '../../../style';
import { PrecompiledUrlTile } from './components/PrecompiledUrlTile';
import { TrackingTile } from './components/TrackingTile';

export const LinkConfigView = () => {
  const { t } = useTranslation(['trackingLinks']);
  const { linkConfigs, site, precompiledLinks } = useTemplateEditorState();
  return (
    <Page>
      <LeftConfigContainer data-testid="LinkConfigView">
        <Heading variation="h2">{t('trackingLinks:templateLevel.leftPanel.heading')}</Heading>
        <Gap top={20} />
        <P>{t('trackingLinks:templateLevel.leftPanel.description', { site: site.name })}</P>

        <Gap top={40} />

        {/* Override tracking links area  */}
        <Box>
          <LogoBox data-testid="SalecycleLogo">
            <Image size={50} src="/images/sc-logo-midnight.svg" />
          </LogoBox>
          {linkConfigs.length > 0 ? (
            <Box>
              <Gap right={40} />
              {linkConfigs.map(element => {
                return <TrackingTile key={element.kind} link={element} />;
              })}
            </Box>
          ) : null}
        </Box>

        <Gap top={40} />
        {/* Edit tracking links area */}
        <Box stackItems={true}>
          <Heading variation="h4">{t('trackingLinks:templateLevel.leftPanel.editLinks')}</Heading>
          {precompiledLinks.length > 0 ? (
            <div>
              <Gap top={40} />
              {precompiledLinks.map(link => {
                return <PrecompiledUrlTile key={`${link.id}.${link.href}`} link={link} />;
              })}
            </div>
          ) : (
            <div>
              <Gap top={20} />
              <P>{t('trackingLinks:templateLevel.leftPanel.noLinks')}</P>
            </div>
          )}
        </Box>
      </LeftConfigContainer>
    </Page>
  );
};
